import { ResponseList } from "./response.model";

export class Caddy {
    name = '';
    code = '';
    location = '';
    description = '';
    image = '';
    id = '';
    locationEmoji: any;
    voiceSample = '';
    personality = '';
    imageUrl = '';
    image2Url = '';
    playing = false;
    accent = ''
    image2 = '';
}
export class CaddyListResponse extends ResponseList {
    override results: Caddy[] = [];
}